module.exports = __webpack_public_path__ + "img/Group 19@2x.da19b24e.png";